import React from 'react';
import { motion } from 'framer-motion';
export const AboutSection = () => {
  const facilitators = [{
    name: 'Nedilena Pereira',
    photo: 'https://cdn.magicpatterns.com/uploads/sj9DC9QycRuNX7dNTGw7Ta/Diseno_sin_titulo_(35).png',
    bio: 'Nedilena cuenta con más de 10 años de experiencia trabajando con el Método Integra®, especializándose en el subconsciente y el mundo energético. Su enfoque está orientado a acompañarte a lograr la vida que realmente deseás vivir, generando cambios profundos desde el interior hacia el exterior. Es facilitadora Nivel 3 y experta en procesos de transformación personal.'
  }, {
    name: 'Vittorio Monasterolo',
    photo: 'https://cdn.magicpatterns.com/uploads/omSbD33fcTpwWoE8LmBfXJ/6929cfd15ad5c_lfgpo.jpg',
    bio: "Con más de 30 años recorriendo el camino espiritual, Vittorio ha dedicado su vida a descifrar y comprender el 'Juego de la Vida', desarrollando una nueva manera de vivir alineada con tu esencia. Es instructor de Yoga Sivananda, terapeuta de Método R'Same, de LNT® y de Método Sama. Autor de la trilogía 'Inspiración para disfrutar de la Era de Acuario'. Diseñador y emprendedor en constante evolución."
  }];
  return <section id="about" className="py-24 bg-white" data-id="element-14">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-16">
          <h2 className="text-4xl md:text-5xl font-bold text-primary mb-4" data-id="element-17">
            Quiénes Somos
          </h2>
          <div className="w-24 h-1 bg-accent mx-auto rounded-full" data-id="element-18"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-19">
          {facilitators.map((person, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: idx * 0.2
        }} className="bg-soft/15 rounded-3xl p-8 md:p-10 border border-soft/30 flex flex-col items-center text-center" data-id="element-20">
              <div className="w-40 h-40 md:w-48 md:h-48 rounded-full overflow-hidden mb-6 border-4 border-accent/30 shadow-lg" data-id="element-21">
                <img src={person.photo} alt={person.name} className="w-full h-full object-cover" data-id="element-22" />
              </div>
              <h3 className="text-2xl font-bold text-primary mb-4" data-id="element-23">
                {person.name}
              </h3>
              <p className="text-primary/70 leading-relaxed text-base md:text-lg" data-id="element-24">
                {person.bio}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};